














import { Component, Vue, Prop } from 'vue-property-decorator';
import ResetPwdBox from '@/auth/ResetPwdBox.vue';

@Component(
{
    components: { ResetPwdBox }
})
export default class ResetRequest extends Vue
{
    @Prop() token!: string;
}
